import { render } from "./BaseNotificationContent.vue?vue&type=template&id=2c6bbf0c&ts=true"
import script from "./BaseNotificationContent.vue?vue&type=script&lang=ts"
export * from "./BaseNotificationContent.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/hound-platform/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__